import React from 'react';
import {
  FACEBOOK_BLACK_ICON, INSTA_BLACK_ICON, SPOTIFY_BLACK_ICON, TWITTER_BLACK_ICON, YOUTUBE_BLACK_ICON,
} from '../image';

const RenderSocialIcons = (item) => {
  const imageToReturn = [];
  if (item.instagram) {
    imageToReturn.push(
      <span className="icon-wrap">
        <img
          src={INSTA_BLACK_ICON}
          alt="instagram"
        />
      </span>,
    );
  }
  if (item.facebook) {
    imageToReturn.push(
      <span className="icon-wrap">
        <img
          src={FACEBOOK_BLACK_ICON}
          alt="facebook"
        />
      </span>,
    );
  }
  if (item.twitter) {
    imageToReturn.push(
      <span className="icon-wrap">
        <img
          src={TWITTER_BLACK_ICON}
          alt="twitter"
        />
      </span>,
    );
  }
  if (item.youtube) {
    imageToReturn.push(
      <span className="icon-wrap">
        <img
          src={YOUTUBE_BLACK_ICON}
          alt="youtube"
        />
      </span>,
    );
  }
  if (item.spotify) {
    imageToReturn.push(
      <span className="icon-wrap">
        <img
          src={SPOTIFY_BLACK_ICON}
          alt="spotify"
        />
      </span>,
    );
  }
  return imageToReturn;
};

export default RenderSocialIcons;
